<app-panel>
  <div class="panel-content">

  </div>
</app-panel>
